import { render, staticRenderFns } from "./myreservations.vue?vue&type=template&id=287cac6f&"
import script from "./myreservations.vue?vue&type=script&lang=js&"
export * from "./myreservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports